// @flow

import * as React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import ReactAI from 'react-appinsights';
import {history} from "../index";

type Props = {
    userAuths?: Array,
};

type State = {
}

class Login extends React.Component<Props, State> {
    
    constructor(props: Props) {
        super(props);
    }

    componentWillMount() {
    }

    componentDidMount() {
        if(this.props.userAuths) {
            history.push("/calculation");
        }
    }

    render() {
        return (<div className="login">
            <h4>Välkommen till Pollex klimatkalkylator</h4>
            <p>Du behöver logga in för att kunna göra dina klimatberäkningar. Vem som helst som har ett Microsoft-konto kan logga in. Du kan till exempel använda ett Microsoft 365-konto från ditt jobb eller privat.</p>
            <p></p>
            <p>Om du inte redan har ett Microsoft-konto kan du enkelt skapa ett nytt under inloggningsprocessen.</p>
            <a href="/.auth/login/aad?post_login_redirect_url=/calculation">Logga in</a>
        </div>);
    };
}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login));




// WEBPACK FOOTER //
// ./src/components/Login.js